(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(['exports', './onelogin', './auth0', './impersonation'], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require('./onelogin'), require('./auth0'), require('./impersonation'));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.onelogin, global.auth0, global.impersonation);
    global.index = mod.exports;
  }
})(this, function (exports, _onelogin, _auth, _impersonation) {
  'use strict';

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.impersonation = exports.auth0 = exports.onelogin = undefined;

  var onelogin = _interopRequireWildcard(_onelogin);

  var auth0 = _interopRequireWildcard(_auth);

  var impersonation = _interopRequireWildcard(_impersonation);

  function _interopRequireWildcard(obj) {
    if (obj && obj.__esModule) {
      return obj;
    } else {
      var newObj = {};

      if (obj != null) {
        for (var key in obj) {
          if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
        }
      }

      newObj.default = obj;
      return newObj;
    }
  }

  exports.onelogin = onelogin;
  exports.auth0 = auth0;
  exports.impersonation = impersonation;
});